<template>
<section>
    <div class="box">
        <div class="icon">
            <img src="../../assets/images/formsuccess.png" alt="">
        </div>
        <p class="title">提交成功</p>
        <p class="description">提交成功，我们会在1-3个工作日内回复您，请在"我的问题"列表查看处理进度</p>
        <div class="ok" @click="ok">好的</div>
    </div>
    <div class="cover"></div>
</section>
    
    
</template>

<script>
export default {
    methods: {
        ok() {
          this.$router.push({ name: 'MyQuiz' })
            this.$emit('input', false)
        }
    }
};
</script>

<style lang="scss" scoped>
.box {
  width: 468px;
  height: 564px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  padding: 60px 48px 32px;
  box-sizing: border-box;
  z-index: 200;
  position: fixed;
  top: 406px;
  left: 142px;
  .icon {
    // width: 144px;
    height: 144px;
    text-align: center;
    img {
      width: 144px;
    }
  }
  .title {
    font-weight: 600;
    font-size: 24px;
    margin-top: 24px;
    margin-bottom: 24px;
    text-align: center;
  }
  .description {
    font-size: 24px;
    margin-bottom: 70px;
    // text-align: center;
    line-height: 1.3;
  }
  .ok {
    width: 100%;
    height: 64px;
    line-height: 64px;
    text-align: center;
    background: rgba(254, 218, 106, 1);
    border-radius: 6px;
  }
}
.cover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  opacity: 0.4;
  z-index: 100;
}
</style>